const invoiceTemplate = `
<!DOCTYPE html>
<html lang="fr">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Facture</title>
    <style>
        body {
            font-family: sans-serif;
            margin: 0; /* Supprime les marges par défaut du body */
            padding: 0;
            font-size: 12pt; /* Taille de police de base pour l'impression */
        }

        /* Styles pour l'impression */
        @media print {
            body {
                margin: 1cm; /* Marge d'1cm sur les bords en impression */
                font-size: 12pt;
            }
            .page-break {
                page-break-before: always; /* Force un saut de page */
            }
        }

        /* Styles pour l'affichage écran */
        @media screen {
          body{
            margin: 20px;
          }
        }

        .a4-page {
            width: 21cm;
            height: 29.7cm;
            margin: 0 auto; /* Centre la page sur l'écran */
            box-sizing: border-box; /* Important pour que padding et border n'affectent pas la taille */
            background-color: white; /* Fond blanc pour l'impression */
            box-shadow: 0 0 5px rgba(0, 0, 0, 0.1); /* Légère ombre pour simuler une feuille sur l'écran */
        }
        .container {
            padding: 1cm; /* Marge intérieure pour le contenu */
        }
        .inner-container {
            padding: 0.05cm 1cm;
        }
        table {
            width: 100%;
            border-collapse: collapse;
            border-spacing: 0;
        }
        td {
            vertical-align: top;
        }
        .w-half {
            width: 50%;
        }
        .text-right {
            text-align: right;
        }
        .text-neutral-600 {
            color: #717171;
        }
        .text-neutral-700 {
            color: #525252;
        }
        .text-lg {
            font-size: 1.2em; /* Utilisation d'em pour une meilleure adaptation */
        }
        .font-bold {
            font-weight: bold;
        }
        .text-primary {
            color: #1c62b4;
        }
        .bg-light-blue {
            background-color: #e3f0ff;
        }
        .my-1 {
            margin-top: 0.25cm;
            margin-bottom: 0.25cm;
        }
        p {
            margin-bottom: 0.5cm;
            line-height: 1.3; /* Ajustement de l'interligne pour l'impression */
        }
    </style>
</head>
<body>
    <div class="a4-page">
        <div class="container">
            <div class="inner-container">
                <table>
                    <tbody>
                        <tr>
                            <td class="w-half">
                                <div class="text-neutral-600" style="border: 1px solid #c7e1ff; border-radius: 20px; padding: 0 20px;">
                                    <p class="text-lg font-bold text-primary" style="margin-bottom: 0">{{company_name}}</p>
                                    <p style="margin-top: 5px">{{company_information}}</p>
                                </div>
                            </td>
                            <td class="w-half text-right">
                                <div class="text-neutral-600">
                                    <p class="text-lg font-bold text-primary" style="margin-bottom: 0">{{customer_name}}</p>
                                    <p style="margin-top: 5px">{{customer_information}}</p>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="bg-light-blue my-1 inner-container" style="margin-top: 1.5cm; margin-bottom: 0.8cm">
                <div class="text-neutral-600">
                    <p class="text-lg font-bold text-primary">Facture {{job_title}}, soins coûtants, n°{{invoice_number}}</p>
                    <p>Fait à {{city}}, le {{date}}</p>
                </div>
            </div>

            <div class="inner-container text-neutral-700">
                <p style="line-height: 1.6">
                    Il a été reçu de {{customer_name}}<br />
                    domicilié(e) {{customer_address}}<br />
                    la somme de {{total_amount_ttc}} réglée par {{payment_method}}<br />
                    pour {{bilan_quantity}} bilan(s) diagnostique kinésithérapique, au prix unitaire de :
                    {{bilan_unit_price}}<br />
                    et {{session_quantity}} séance(s), au prix unitaire de : {{session_unit_price}}<br />
                    effectuées le :<br />
                    {{session_dates}}
                    <br /><br />
                    Pour ce règlement, une télétransmission à l’Assurance Maladie a été réalisée, correspondant à la prescription
                    médicale établie le {{prescription_date}} par le docteur {{doctor_name}}.
                    <br /><br />
                    Cette somme se décompose comme suit :<br />
                    · {{refundable_treatments}} pour les actes remboursables par l’Assurance Maladie {{cotation_acte}}<br />
                    · {{non_refundable_treatments}} pour les actes complémentaires associés non remboursables par l’Assurance
                    Maladie<br />
                    <br />
                    (TVA non applicable article 261 du CGI)
                </p>
            </div>
        </div>
    </div>
</body>
</html>
    `;

export default invoiceTemplate;
